<div class="app-page">

     <h2>
        <span class="material-symbols-outlined" style="font-size: 36px;">
            data_table
        </span>
        SEASONS
    </h2>
    <mat-divider></mat-divider>
     @if(!this.currentSeasonAvailable){
        <h4 style="color: gray;">
            <mat-icon>warning</mat-icon>
            There is no season avaible for todays date (no active season). Contact Dalecarlia Scouting to request new season.
        </h4>
        
        <br>
     }

      <table mat-table [dataSource]="this.dataSource" class="mat-elevation-z8" style="width:100%;">
    
         <!-- Season Id Column -->
        <ng-container matColumnDef="SeasonId">
          <th mat-header-cell *matHeaderCellDef> Season Id </th>  
          <td mat-cell *matCellDef="let element"> {{element.SeasonId}} </td>
        </ng-container>


          <!-- Season Id Column -->
        <ng-container matColumnDef="IsCurrent">
          <th mat-header-cell *matHeaderCellDef> Current season</th>  
          <td mat-cell *matCellDef="let element"> {{element.IsCurrent ? 'Yes' : 'No'}} </td>
        </ng-container>

        <!-- Season Name Column -->
        <ng-container matColumnDef="Name">
          <th mat-header-cell *matHeaderCellDef> Season Name </th>  
          <td mat-cell *matCellDef="let element"> {{element.Name}} </td>
        </ng-container>
    
        <!-- Start Date Column -->
        <ng-container matColumnDef="StartDate">
          <th mat-header-cell *matHeaderCellDef> Start Date </th>
          <td mat-cell *matCellDef="let element"> {{element.SeasonStartDate | date}} </td>
        </ng-container>
    
        <!-- End Date Column -->
        <ng-container matColumnDef="EndDate">
          <th mat-header-cell *matHeaderCellDef> End Date </th>
          <td mat-cell *matCellDef="let element"> {{element.SeasonEndDate | date}} </td>
        </ng-container>
    
        <!-- Header and Row Declarations -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
        <mat-paginator [length]="dataSource?.data?.length || 0"
                 [pageSize]="20"
                 [pageSizeOptions]="[20]"
                 showFirstLastButtons>
        </mat-paginator>

</div>
